export const FEATURE_FLAG_MAINTENANCE_REFERENCE_DOCUMENTS = "maintenance-reference-documents"
